import React from 'react';
import { SvgIcon, Tag } from '@agilize/components-core';
import { useLeadContext } from '@context/LeadContext';
import { parseISO, format } from 'date-fns';
import { useHistory } from 'react-router-dom';
import { CardContainer, LeftSide, Header, Title, InformationSection, Content, InfoTitle, InfoValue, Col } from './LeadCard.styles';
import { LeadCardProps } from './LeadCard.types';

const LeadCard = (props: LeadCardProps) => {
  const history = useHistory();
  const { lead } = props;
  const { setLead } = useLeadContext();

  const redirectRouter = () => {
    setLead(lead);
    return history.push('/');
  };

  return (
    <CardContainer onClick={redirectRouter}>
      <LeftSide>
        <Header>
          <Col>
            <Tag type="confirmation" variant="light">
              {lead.leadTypeLabel}
            </Tag>
          </Col>
          <Title>{lead.name}</Title>
        </Header>
        <InformationSection>
          <Col>
            <Content>
              <InfoTitle>Data de criação</InfoTitle>
              <InfoValue>{format(parseISO(lead.createdAt), 'dd/MM/yyyy')}</InfoValue>
            </Content>
          </Col>
          <Content>
            <InfoTitle>Etapa de preenchimento</InfoTitle>
            <InfoValue>{lead.lastStep && lead.lastStep.split(' - ')[1]}</InfoValue>
          </Content>
        </InformationSection>
      </LeftSide>
      <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/unicons/angle-right.svg`} width={24} height={24} fill="grey700" />
    </CardContainer>
  );
};

export default LeadCard;
